
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Title extends Vue {
  @Prop({ default: "" }) readonly text!: string;
  i: number = 0;
  speed = 1000 / 30;
  content = "";

  mounted() {
    this.Typewriter();
  }

  text1 = "NEW QUEST UNLOCKED";
  text2 = "- Seek revenge against Dareth Schamren -";
  text3 = "> Continue";

  line1 = "";
  line2 = "";
  line3 = "";

  Typewriter() {
    if (this.text1.length > 0) {
      this.line1 += this.text1.slice(0, 1);
      this.text1 = this.text1.slice(1);
      setTimeout(this.Typewriter, this.speed);
    } else if (this.text2.length > 0) {
      this.line2 += this.text2.slice(0, 1);
      this.text2 = this.text2.slice(1);
      setTimeout(this.Typewriter, this.speed);
    } else if (this.text3.length > 0) {
      this.line3 += this.text3.slice(0, 1);
      this.text3 = this.text3.slice(1);
      setTimeout(this.Typewriter, this.speed);
    }
  }
}
